module.exports = __webpack_public_path__ + "static/media/eg.c39a7f7e.svg";